var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-2"},[_c('strong',[_vm._v("Contact List")]),_c('a-table',{staticClass:"mt-2",attrs:{"size":"small","columns":_vm.columnDefs,"dataSource":_vm.dataDefs,"scroll":{ y: 300 },"pagination":{
          defaultPageSize: 200,
          showQuickJumper: true,
          showSizeChanger: true,
          showTotal: (total) => `Total ${total} items`,
          pageSizeOptions: ['10', '20', '30'],
          hideOnSinglePage: true,
        }},scopedSlots:_vm._u([{key:"action",fn:function(text, record){return _c('span',{},[_c('a',{staticClass:"text-primary",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.showProfilePicture(record)}}},[_vm._v(" Show Profile Picture ")])])}}])})],1)]),_c('zoomgambar',{ref:"zoomgambar"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }